import type { ReactNode } from 'react';
import { Box, Card, CardActionArea, CardContent, Skeleton, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export interface KpiCardProps {
  label: string;
  value: string | number;
  loading?: boolean;
  icon?: ReactNode;
  /** Opcional: clicar leva à tela origem. */
  to?: string;
  /** Caption secundária (ex.: "Maio/2026"). */
  caption?: string;
}

export function KpiCard({ label, value, loading, icon, to, caption }: KpiCardProps): JSX.Element {
  const content = (
    <CardContent>
      <Stack direction="row" spacing={2} alignItems="center">
        {icon && (
          <Box
            sx={{
              width: 48,
              height: 48,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 1,
              bgcolor: 'action.hover',
              color: 'primary.main',
            }}
          >
            {icon}
          </Box>
        )}
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant="body2" color="text.secondary" noWrap>
            {label}
          </Typography>
          {loading ? (
            <Skeleton variant="text" width={120} height={36} />
          ) : (
            <Typography variant="h5" component="p" sx={{ fontWeight: 600 }}>
              {value}
            </Typography>
          )}
          {caption && (
            <Typography variant="caption" color="text.disabled">
              {caption}
            </Typography>
          )}
        </Box>
      </Stack>
    </CardContent>
  );

  if (to) {
    return (
      <Card variant="outlined" sx={{ height: '100%' }}>
        <CardActionArea component={RouterLink} to={to} sx={{ height: '100%' }}>
          {content}
        </CardActionArea>
      </Card>
    );
  }
  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      {content}
    </Card>
  );
}
